/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ChromeBarPlaceholderWidget", ["WidgetPlaceholderBase", "WidgetFactory"], function (context, cls) {
  /**
   * ChromeBarPlaceholderWidget widget.
   * @class TopMenuPlaceholderWidget
   * @memberOf classes
   * @extends classes.WidgetPlaceholderBase
   * @publicdoc Widgets
   */
  cls.ChromeBarPlaceholderWidget = context.oo.Class(cls.WidgetPlaceholderBase, function ($super) {
    return /** @lends classes.ChromeBarPlaceholderWidget.prototype */ {
      __name: "ChromeBarPlaceholderWidget"
    };
  });
  cls.WidgetFactory.registerBuilder("ChromeBarPlaceholder", cls.ChromeBarPlaceholderWidget);
});
